import _ from 'lodash'

export const checkLoading = actions => state => {
    return _(actions)
        .some( action => _.get( state, `loading.${action}` ))
}
